export default __webpack_public_path__ + "static/media/Brisbane-2022.8554d020.jpg";